import React, { useContext, useState } from 'react';
import { CsvDataContext } from '../utils/CsvDataContext';
import { normalizeData } from '../utils/dataUtils';
import SideDrawer from '../components/SideDrawer';
import CallEventList from '../components/CallCharts/CallEventList';
import CallFiltersPanel from '../components/calls/CallFiltersPanel';
import CallChartsSection from '../components/calls/CallChartsSection';
import CallDrawerContent from '../components/calls/CallDrawerContent';
import { PageContainer, Section } from '../components/layout/PageContainer';

const AgentRejectCalls = () => {
  const { csvData, setCsvData } = useContext(CsvDataContext);
  const [fileName, setFileName] = useState(null);
  const [filters, setFilters] = useState({ customer: '', agent: '', selectedDate: '' });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerMode, setDrawerMode] = useState(null);

  const handleCsvParsed = (parsedData, name) => {
    setCsvData(normalizeData(parsedData));
    setFileName(name);
  };

  const handleDeleteFile = () => {
    setCsvData([]);
    setFileName(null);
  };

  const handleDrawerMode = (mode) => {
    setDrawerMode(mode);
    setDrawerOpen(true);
  };

  return (
    <PageContainer>
      <div style={{ display: 'flex', width: '100%' }}>
        {csvData.length > 0 && (
          <SideDrawer
            isOpen={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            onModeChange={handleDrawerMode}
            width={400}
            collapsedWidth={60}
            drawerMode={drawerMode}
          >
            <CallDrawerContent mode={drawerMode} data={csvData} filters={filters} />
          </SideDrawer>
        )}
        <div style={{ flex: 1, paddingBottom: 0, width: '100%' }}>
          <Section>
            <CallFiltersPanel
              csvData={csvData}
              filters={filters}
              setFilters={setFilters}
              fileName={fileName}
              onParsed={handleCsvParsed}
              onDelete={handleDeleteFile}
            />
          </Section>
          <CallChartsSection data={csvData} filters={filters} />
        </div>
      </div>
      {csvData.length > 0 && <CallEventList data={csvData} filters={filters} />}
    </PageContainer>
  );
};

export default AgentRejectCalls;
